<template>
  <div class="animate-fade-in">
    <!-- Header -->
    <div class="flex justify-between items-center mb-12">
      <button
        @click="goBack"
        class="inline-flex items-center gap-2 text-sm text-stone-500 hover:text-stone-800 dark:hover:text-stone-200 transition-colors group"
      >
        <svg
          class="w-4 h-4 transition-transform group-hover:-translate-x-1"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
          />
        </svg>
        Back
      </button>

      <dark-mode-toggle />
    </div>

    <!-- Project Content -->
    <div class="space-y-4">
      <div class="space-y-4">
        <header class="space-y-1.5">
          <div
            class="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.18em] text-stone-500 dark:text-stone-500"
          >
            <span class="h-1.5 w-1.5 rounded-full bg-brand-500"></span>
            Project Overview
          </div>
          <h1
            class="font-display text-[24px] sm:text-[28px] font-bold text-stone-900 dark:text-stone-50 tracking-tight"
          >
            {{ currentProject?.name }}
          </h1>
          <a
            v-if="currentProject?.projectUrl"
            :href="currentProject?.projectUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex items-center gap-2 text-sm font-semibold text-stone-800 dark:text-stone-100 hover:text-stone-600 dark:hover:text-stone-200 transition-colors"
          >
            <span>View Live Project</span>
            <svg
              class="w-4 h-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
              />
            </svg>
          </a>
        </header>

        <div class="space-y-4">
          <div class="prose-minimal text-stone-700 dark:text-stone-200">
            <custom-text :value="currentProject?.description" />
          </div>

          <div v-if="techPills.length" class="flex flex-wrap gap-2">
            <span
              v-for="tech in techPills"
              :key="tech"
              class="inline-flex items-center px-3 py-1 rounded-full bg-stone-100 dark:bg-stone-800 text-stone-700 dark:text-stone-300 text-[12px] font-medium"
            >
              {{ tech }}
            </span>
          </div>
        </div>
      </div>

      <div class="overflow-hidden">
        <project-image-gallery :images="currentProject?.images" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ProjectImageGallery from "@/components/common/ProjectImageGallery.vue";
import CustomText from "@/components/common/CustomText.vue";
import DarkModeToggle from "@/components/common/DarkModeToggle.vue";
import { useRoute, useRouter } from "vue-router";
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { usePortfolioStore } from "@/store/portfolioStore";

const route = useRoute();
const router = useRouter();
const portfolioStore = usePortfolioStore();
const { portfolio } = storeToRefs(portfolioStore);

const currentProject = computed(() => {
  return portfolio.value?.projects.find(
    (project) => project.slug === route.params.slug
  );
});

const techPills = computed(() => {
  return (
    currentProject.value?.technologies?.map((t) => t.name).filter(Boolean) || []
  );
});

const goBack = () => {
  router.back();
};
</script>
